// 在线评估-人事中心
<template>
  <div class="est-box-main" v-if="isRefresh">
    <div class="sub-top-line">
      <!-- <el-button size="medium" class="btn-icon-36" icon="el-icon-s-data" @click="showStatistics()"></el-button> -->
      <el-button size="medium" class="btn-text-4 btn-icon-1ab394" type="primary" @click="setPost">设立职务</el-button>
      <el-button size="medium" class="btn-text-4 btn-icon-1ab394" type="primary" @click="setAuthorization">设置权限</el-button>
      <el-button size="medium" class="btn-text-4" v-if="addStaffFlag" type="primary" @click="addStaffA">新增成员</el-button>
      <el-button size="medium" class="btn-text-4" icon="el-icon-refresh-right" @click="handleRefresh">刷新</el-button>
    </div>
    <div class="mainTable">
      <table class="listTable" width="100%" border="1" align="center">
        <tr>
          <th class="cell thtitle" width="4%">序号</th>
          <!-- <th class="cell thtitle" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th> -->
          <th class="cell thtitle" v-for="(th, thi) in tableNamesS" :key="thi">{{th}}</th>
          <th class="cell thtitle" width="12%">操作</th>
        </tr>
        <tr v-for="(tr, tri) in tabDataCrt.tableData" :key="tri">
          <td class="cell tdcell">{{(pageNo - 1) * pages + tri + 1}}</td>
          <!-- <td class="cell tdcell" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi"> -->
          <td class="cell tdcell" v-for="(td, tdi) in rowItemsS" :key="tdi">
            <el-input v-if="tr.editFlag" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
          <td class="cell tdcell">
            <el-button class="text-btn" type="text" size="mini" @click="showDetails(tr)">主表详情</el-button><br>
            <!-- <el-button class="text-btn" type="text" size="mini" @click="showProSitTable(tr)">项目情况表</el-button> -->
            <!-- <el-button class="text-btn" type="text" size="mini" @click="deleteRow(tr)">删除</el-button> -->
            <!-- <el-button type="text" size="mini" @click="makeSure(item)">上传文件</el-button> -->
            <el-button class="text-btn" type="text" size="mini" @click="editStaff(tr)">人事管理</el-button><br>
            <!-- <el-button class="text-btn" type="text" size="mini" @click="showLogger(tr)">进度</el-button><br> -->
          </td>
        </tr>
      </table>
    </div>
    <!-- other -->
    <div class="bottom-pagination">
      <el-pagination
        hide-on-single-page
        small
        background
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="pages"
        :current-page="pageNo"
        :total="totalNumber">
      </el-pagination>
    </div>
    <nut-dialog
      @close="showDetailsDialogFlag = false"
      v-if="showDetailsDialogFlag"
      :visible="showDetailsDialogFlag"
      title="详情"
      :noFooter="true">
      <div class="details-dialog-main">
        <table>
          <template v-for="(title, tindex) in tableNamesD">
            <tr :key="tindex*2">
              <th>{{ title }}</th>
            </tr>
            <tr :key="tindex*2+1">
              <td>{{ detailsRow[rowItemsD[tindex]] }}</td>
            </tr>
          </template>
        </table>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showLoggerFlag = false"
      v-if="showLoggerFlag"
      :visible="showLoggerFlag"
      title="操作进度"
      :noFooter="true">
      <!-- <el-timeline :reverse="reverse">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :timestamp="activity.timestamp">
          {{activity.operator}}<br>
          {{activity.operationType}}<br>
          {{activity.operationDetails}}<br>
          {{activity.operationOpinion}}<br>
        </el-timeline-item>
      </el-timeline> -->
      <div class="logger-dialog-main">
        <table>
          <tr v-for="(activity, index) in activities" :key="index">
            <td>
              <p class="text-time">{{ activity.timestamp }}</p>
              <p class="text-main">{{ activity.operator }}</p>
              <p class="text-main">{{ activity.operationType }}</p>
              <p class="text-main">{{ activity.operationDetails }}</p>
              <p class="text-main">{{ activity.operationOpinion }}</p>
            </td>
          </tr>
        </table>
      </div>
      <div class="bottom-pagination">
        <el-pagination
          hide-on-single-page
          small
          background
          layout="prev, pager, next, jumper"
          @current-change="handleCurrentChangeL"
          :page-size="pagesL"
          :current-page="currentPageL"
          :total="totalNumberL">
        </el-pagination>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showEditStaffFlag = false; getTabData(pageNo)"
      v-if="showEditStaffFlag"
      :visible="showEditStaffFlag"
      title="人事管理"
      :noFooter="true">
      <div class="prosit-main-box">
        <div class="prosit-main-scroll-box">
          <div class="line-input line-single">
            <span class="label-4">姓名</span>
            <el-input class="input-s4" v-model="crtRow.name" disabled></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-4">职务</span>
            <select class="input-s4" v-model="crtRow.post">
              <option v-for="item in postOptions" :key="item.value" :label="item.label" :value="item.label"></option>
            </select>
            <!-- <el-input class="input-s4d2" v-model="projectInfo.department" placeholder="可填写其他部门"></el-input> -->
          </div>
          <div class="line-input line-single">
            <span class="label-4">状态</span>
            <select class="input-s4" v-model="crtRow.type">
              <option label="在职" value="在职"></option>
              <option label="待职" value="待职"></option>
              <option label="离职" value="离职"></option>
            </select>
          </div>
          <div class="line-input line-textarea">
            <span class="label-4">备注</span>
            <el-input class="input-s4" type="textarea" v-model="crtRow.remarks"></el-input>
          </div>
          <div class="line-input line-button">
            <el-button class="btn-icon-36 center-btn img-icon-save" icon="el-icon-minus" type="primary" @click="saveStaff(crtRow)"></el-button>
          </div>
        </div>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showSetPostFlag = false"
      v-if="showSetPostFlag"
      :visible="showSetPostFlag"
      title="设立职务"
      :noFooter="true">
      <div class="prosit-main-box">
        <div class="prosit-main-scroll-box">
          <div class="line-input line-textarea">
            <span class="label-full">请从职务级别高到低输入职务名称（一次性输入），以中文逗号相隔，如“领导层，评估人员，环保管理部门，办公室”</span>
          </div>
          <div class="line-input line-textarea">
            <el-input class="input-full" type="textarea" v-model="setPostValue"></el-input>
          </div>
          <div class="line-input line-button">
            <el-button class="input-s4d2 center-btn btn-text" type="primary" @click="doSetPost(setPostValue)">确定</el-button>
          </div>
        </div>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showSetAuthorizationFlag = false"
      v-if="showSetAuthorizationFlag"
      :visible="showSetAuthorizationFlag"
      title="选择职务设置权限"
      :noFooter="true">
      <div class="prosit-main-box">
        <div class="prosit-main-scroll-box">
          <div class="line-input line-single">
            <select class="input-full" v-model="setAuthorizationObj.post">
              <option v-for="item in postOptions" :key="item.value" :label="item.label" :value="item.label"></option>
            </select>
          </div>
          <div class="line-input line-button">
            <el-button class="input-s6d2 center-btn btn-text" @click="selectAll()">全选</el-button>
            <el-button class="input-s6d2 center-btn btn-text" type="primary" @click="doSetAuthorization(setPostValue)">提交</el-button>
            <el-button class="input-s6d2 center-btn btn-text" @click="removeAll()">重置</el-button>
          </div>
          <div class="line-input line-multiSelect">
            <div class="multiselector">
              <el-button
                v-for="(item, index) in setAuthorizationObj.setAuthorizationAll" :key="index"
                :type="setAuthorizationObj.setAuthorization.indexOf(item) > -1 ? 'primary' : ''"
                class="ms-option" @click="selectOne(item)" size="small">
                <span v-if="item !== '在线评估' && item !== '系统管理'">{{ item }}</span>
                <b v-if="item === '在线评估' || item === '系统管理'"><u>{{ item }}</u></b>
              </el-button>
            </div>
          </div>
          <!-- <div class="line-input line-multiSelect">
            <div class="multiselector">
              <el-button
                v-for="(item, index) in setAuthorizationObj.setAuthorizationSysAll" :key="index"
                :type="setAuthorizationObj.setAuthorizationSys.indexOf(item) > -1 ? 'primary' : ''"
                class="ms-option" @click="selectOne(item)" size="small">
                {{ item }}
              </el-button>
            </div>
          </div> -->
        </div>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showAddStaffAFlag = false"
      v-if="showAddStaffAFlag"
      :visible="showAddStaffAFlag"
      title="新增成员"
      :noFooter="true">
      <div class="prosit-main-box">
        <div class="prosit-main-scroll-box">
          <div class="line-input line-textarea">
            <span class="label-full">请输入新成员在线评估账号的所属手机号，如需批量增加，在每个手机号之间用中文逗号“，”隔开</span>
          </div>
          <div class="line-input line-textarea">
            <el-input class="input-full" type="textarea" v-model="addStaffAValue"></el-input>
          </div>
          <div class="line-input line-button">
            <el-button class="input-s4d2 center-btn btn-text" type="primary" @click="doAddStaffA(addStaffAValue)">确定</el-button>
          </div>
        </div>
      </div>
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../../api/indexForCoe'
export default {
  data () {
    return {
      pageCategory: '人事中心',
      pageRouter: '/estOverview',
      tabType: 'tabA',
      companyName: '',
      phone: sessionStorage.getItem('qs_phone'),
      // tabData
      tabData: [
        {
          tabTitle: '在线评估-人事中心',
          tabIndex: 'tabA',
          tabType: 'table',
          tableNames: [
            '姓名',
            '职务',
            '状态',
            '备注'
          ],
          rowItems: [
            'name',
            'post',
            'type',
            'remarks'
          ],
          api: {
            add: 'appUserAdd',
            enquiry: 'appUserEnquiry',
            update: 'appUserUpdate',
            delete: 'appUserDelete',
            extraParam: {
              // phone: sessionStorage.getItem('qs_phone'),
              // type: '人事中心'
              staffing: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        }
      ],
      tabDataCrt: {},
      tableNamesS: [
        '姓名',
        '职务',
        '状态'
        // '备注'
      ],
      rowItemsS: [
        'name',
        'post',
        'type'
        // 'remarks'
      ],
      tableNamesD: [
        '姓名',
        '职务',
        '状态',
        '备注'
      ],
      rowItemsD: [
        'name',
        'post',
        'type',
        'remarks'
      ],
      pages: 10,
      pageNo: 1,
      totalNumber: 1,
      isRefresh: true,
      // jindu: false,
      // percentage: 10,
      // text1: '',
      // importFlag: false,
      extaParam: {},
      wordInfo: false,
      detailsRow: {},
      showDetailsDialogFlag: false,
      showLoggerFlag: false,
      activities: [],
      pagesL: 5,
      currentPageL: 1,
      totalNumberL: 0,
      showProSitFormFlag: false,
      showEditStaffFlag: false,
      eiaStatusId: 0,
      crtRow: {},
      addStaffFlag: false,
      companyId: '',
      company: '',
      showSetPostFlag: false,
      setPostValue: '',
      showSetAuthorizationFlag: false,
      setAuthorizationObj: {
        post: '',
        setAuthorization: [],
        setAuthorizationAll: ['在线评估', '汇总', '受理', '待分配', '待评估', '会议通知', '评估', '审核', '审定', '存档', '系统管理', '人事中心']
        // setAuthorizationEia: [],
        // setAuthorizationSys: [],
        // setAuthorizationEiaAll: ['在线评估', '汇总', '受理', '待分配', '待评估', '会议通知', '评估', '审核', '审定', '存档'],
        // setAuthorizationSysAll: ['系统管理', '人事中心']
      },
      showAddStaffAFlag: false,
      addStaffAValue: ''
    }
  },
  mounted () {
    this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
    api.appUserHighestPosition({
      phone: this.phone
    }).then(res => {
      this.addStaffFlag = res.data.highestPosition
      console.log(res)
      this.companyId = res.data.companyId
      this.company = res.data.company
    })
    api.companyNameEnquiryOne({
      phone: this.phone
    }).then(res => {
      if (res.code === 200) {
        let value = '领导层，评估人员，环保管理部门，办公室'
        if (res.data) {
          value = res.data
        }
        this.setPostValue = value
        this.postOptions = []
        var posts = value.split('，')
        for (let i = 0; i < posts.length; i++) {
          this.postOptions.push({
            value: '选项' + i,
            label: posts[i]
          })
        }
      }
    })
    this.getTabData()
  },
  methods: {
    getTabData (pageNo = 1) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.enquiry]({
          pageNo: pageNo,
          pages: 10,
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.totalNumber = res.data.totalNumber
          var tempArr = []
          res.data.list.forEach(item => {
            var arrPusher = {
              id: item.id,
              editFlag: false
            }
            this.tabDataCrt.rowItems.forEach(rowItem => {
              arrPusher[rowItem] = item[rowItem] || ''
            })
            tempArr.push(arrPusher)
          })
          this.tabDataCrt.tableData = tempArr
          console.log(this.tabDataCrt.tableData)
        })
      } else if (this.tabDataCrt.tabType === 'multiform') {
      }
    },
    handleRefresh () {
      this.getTabData()
    },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTabData(this.pageNo)
    },
    // closeIF () {
    //   this.importFlag = false
    // },
    // addRow () {
    //   this.importFlag = true
    // },
    // handleSuccess () {
    //   this.$toast.text('上传成功')
    //   this.getTabData()
    // },
    // checkUpload () {
    //   this.$refs.uploadRef.doUpload()
    // },
    // closeWI () {
    //   this.wordInfo = false
    // },
    // addTerm () {
    //   this.wordInfo = true
    // },
    // editRow (row) {
    //   // row.editFlag = true
    //   this.percentage = 0
    //   this.jindu = true
    //   var bianliang = setInterval(() => {
    //     this.percentage = this.percentage + 1
    //     if (this.percentage >= 99) {
    //       clearInterval(bianliang)
    //     }
    //   }, 1000)
    //   api.cdSummaryTableDownload({
    //     id: row.id
    //   }).then(res => {
    //     console.log(res)
    //     if (res.code === 200) {
    //       window.open(res.data)
    //       this.percentage = 100
    //       clearInterval(bianliang)
    //       setTimeout(() => {
    //         this.jindu = false
    //       }, 1000)
    //     } else {
    //       clearInterval(bianliang)
    //       this.text1 = res.message
    //     }
    //     // if (res.code === 40001) {
    //     //   this.jindu = false
    //     // }
    //   })
    // },
    // saveRow (row) {
    //   if (this.tabDataCrt.tabType === 'table') {
    //     var savePusher = {
    //       id: row.id,
    //       ...this.tabDataCrt.api.extraParam
    //     }
    //     this.tabDataCrt.rowItems.forEach(rowItem => {
    //       console.log(row, rowItem, row[rowItem])
    //       savePusher[rowItem] = row[rowItem] || ''
    //     })
    //     api[this.tabDataCrt.api.update](savePusher).then(res => {
    //       console.log(res)
    //       this.$nextTick(() => {
    //         this.isRefresh = true
    //         this.pageNo = 1
    //         this.getTabData()
    //       })
    //     })
    //   }
    // },
    deleteRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.delete]({
          id: row.id
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    showDetails (row) {
      console.log(row)
      this.detailsRow = row
      this.showDetailsDialogFlag = true
    },
    showLogger (row) {
      console.log(row)
      this.detailsRow = row
      this.showLoggerFlag = true
      this.getJournalt(1)
    },
    getJournalt (pageNo = 1) {
      api.cdEiaJournalEnquiry({
        pages: 5,
        pageNo: pageNo,
        superiorId: this.detailsRow.id
      }).then(res => {
        console.log(res)
        this.totalNumberL = res.data.totalNumber
        var centerArr = []
        if (res.data.totalNumber !== 0) {
          res.data.list.forEach(item => {
            centerArr.push({
              operator: item.operator,
              operationType: item.operationType,
              timestamp: item.operationTime,
              operationDetails: item.operationDetails,
              operationOpinion: item.operationOpinion
            })
            this.activities = centerArr
          })
        } else if (res.data.totalNumber === 0) {
          this.activities = []
        }
        // this.activities.reverse()
      })
    },
    handleCurrentChangeL (currentPage) {
      this.currentPageL = currentPage
      this.getJournalt(this.currentPageL)
    },
    // showReportUpload (row) {
    //   this.eiaStatusId = row.order
    //   this.upOtherFileFlag = true
    // },
    showProSitTable (row) {
      this.eiaStatusId = row.id
      this.showProSitFormFlag = true
    },
    closeProSitForm (changePath) {
      this.showProSitFormFlag = false
      if (changePath) {
        this.$emit('doChangePath', changePath)
      }
    },
    editStaff (row) {
      this.eiaStatusId = row.id
      this.crtRow = row
      this.showEditStaffFlag = true
    },
    saveStaff (row) {
      api.appUserUpdate({
        staffing: 1,
        id: row.id,
        name: row.name,
        post: row.post,
        type: row.type,
        remarks: row.remarks
      }).then(res => {
        console.log(res)
        this.showEditStaffFlag = false
        this.getTabData(this.pageNo)
      })
      // this.addLogger('保存')
    },
    setPost () {
      this.showSetPostFlag = true
    },
    doSetPost (value) {
      if (!value) {
        this.$toast.text('请输入职务名称!')
      } else {
        var posts = value.split('，')
        console.log(value)
        this.postOptions = []
        for (let i = 0; i < posts.length; i++) {
          this.postOptions.push({
            value: i,
            label: posts[i]
          })
        }
        api.companyNameUpdate({
          postList: value
        }).then(res => {
          this.showSetPostFlag = false
        })
      }
    },
    setAuthorization () {
      this.showSetAuthorizationFlag = true
    },
    selectOne (item) {
      var selectOneIndex = this.setAuthorizationObj.setAuthorization.indexOf(item)
      if (selectOneIndex > -1) {
        this.setAuthorizationObj.setAuthorization.splice(selectOneIndex, 1)
      } else {
        this.setAuthorizationObj.setAuthorization.push(item)
      }
    },
    selectAll () {
      this.setAuthorizationObj.setAuthorization = ['在线评估', '汇总', '受理', '待分配', '待评估', '会议通知', '评估', '审核', '审定', '存档', '系统管理', '人事中心']
    },
    removeAll () {
      this.setAuthorizationObj.setAuthorization = []
    },
    doSetAuthorization () {
      var strData = ''
      this.setAuthorizationObj.setAuthorization.forEach(element => {
        strData = strData + element + ','
      })
      api.jcJurisdictionAdd({
        post: this.setAuthorizationObj.post,
        jurisdiction: strData,
        staffing: 1,
        phone: this.phone
      }).then(res => {
        if (res.code === 200) {
          console.log(res)
          this.$toast.text('提交成功，重启应用后生效')
        }
      })
    },
    addStaffA () {
      this.showAddStaffAFlag = true
    },
    doAddStaffA (value) {
      if (!value) {
        this.$toast.text('请输入手机号!')
      } else {
        api.appUserPhone({
          companyId: this.companyId,
          company: this.company,
          phone: value,
          phoneA: this.phone,
          staffing: 1
        }).then(res => {
          this.showAddStaffAFlag = false
          this.getTabData()
        })
      }
    }
  },
  components: {
    // eiaTableImport,
    // protectionMap
    // api,
    // showTableData () {
    //   return this.tableData
    // }
  }
}
</script>

<style lang="scss">
.est-box-main{
  z-index: 0;
  height: 100%;
  overflow-y: auto;
  .sub-top-line {
    height: 36px;
    padding: 10px 0 0 0;
  }
  .mainTable{
    margin: 10px;
    width: calc(100% - 20px);
    word-break: break-all;
    .tableFileCell{
      text-decoration: underline;
      color: #00C;
    }
    .tableFileCell:hover{
      color: #66F;
      text-decoration: none;
    }
    .cell{
      border: 1px #ccc solid;
      text-align: center;
    }
    .thtitle{
      background-color: #fafafa;
      line-height: 24px;
    }
    .tdcell{
      background-color: #fff;
      line-height: 32px;
      padding: 2px;
      .el-input__inner{
        height: 28px!important;
      }
      .text-btn {
        margin: 0!important;
      }
    }
  }
  .bottom-pagination .el-pagination {
    text-align: right;
    margin-top: 6px;
    margin-bottom: 6px;
  }
  .details-dialog-main{
    table {
      word-break: break-all;
      width: 100%;
      height: 100%;
      border-top: 1px #999 solid;
      border-left: 1px #999 solid;
      th {
        color: #000;
      }
      th, td {
        padding: 12px 0;
        color: #333;
        border-right: 1px #999 solid;
      }
      th {
        border-bottom: 1px #999 solid;
      }
      td {
        border-bottom: 1px #999 solid;
      }
    }
  }
  .logger-dialog-main {
    table {
      word-break: break-all;
      width: 100%;
      // height: calc(100% - 32px);
      height: 100%;
      td {
        padding: 8px 0;
        border-bottom: 1px #f3f4f5 solid;
        text-align: left;
      }
    }
    .text-time {
      color: #409EFF;
    }
    .text-main {
      color: #333;
    }
  }
  .pro-sit-box {
    height: 100vh;
    width: 100vw;
    background: #fff;
    position: absolute;
    top: 0;
    z-index: 999;
  }
}
</style>
